<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-07 17:54:46
 * @FilePath: \mrc-base-frontend\src\views\pushMessageTopic\detailMessageTopic.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 09:46:46
-->
<template>
  <div>
    <Info :disabled="disabled" @changeReadonly="changeReadonly" />
  </div>
</template>
<script>
import Info from "./modules/info.vue";
export default {
  components: { Info },
  data() {
    return {
      disabled: false,
    };
  },
  mounted() {
    const uuid = this.$route.params.uuid || this.$store.state.uuid;
    this.disabled = this.$store.state.iconstatus;
    this.uuid = uuid;
    // 功能详情
    if (this.uuid) {
      if (!this.$store.state.iconstatus) {
        this.disabled = false;
        this.$store.commit("set_iconstatus", false);
      }
    }
  },
  methods: {
    changeReadonly() {
      this.disabled = !this.disabled;
    },
  },
};
</script>